import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { Notification } from '../../interfaces/notification';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('openClose', [
      state('opened', style({
        height: '*',
      })),
      state('closed', style({
        height: 'calc(25px * var(--notification-text-lines))',
        '-webkit-line-clamp': 'var(--notification-text-lines)',
        '-webkit-box-orient': 'vertical'
      })),
      transition('opened => closed', [
        animate('.2s')
      ]),
      transition('closed => opened', [
        animate('0.2s')
      ])
    ])
  ]
})
export class NotificationComponent implements AfterViewInit {
  @Input() data!: Notification;
  @Input() settings!: any;
  @HostBinding('class.loaded') loaded: boolean = false;
  @HostBinding('class.disabled') @Input() disabled?: boolean = false;
  fullText: boolean = false;
  showFullText: boolean = false;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.detectFullText();
  }

  detectFullText() {
    const textBoxHeight = this.el.nativeElement.querySelector('.notification-text-box').offsetHeight;
    const textHeight = this.el.nativeElement.querySelector('.notification-text').offsetHeight;

    this.fullText = textHeight > textBoxHeight;
    this.loaded = true;
  }

  formatDateDifference(timestamp: string) {
    if(!this.settings.dayFormat) return;
    const currentDate = new Date();
    const timestampDate = new Date(timestamp);

    const diffInMilliseconds = currentDate.getTime() - timestampDate.getTime();
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
    const diffInDays = diffInHours / 24;
    const diffInMinutes = diffInMilliseconds / (1000 * 60);

    if (diffInDays >= 1) {
      return this.settings.dayFormat.replace('{0}', Math.floor(diffInDays).toString());
    } else if (diffInHours >= 1) {
      return this.settings.hourFormat.replace('{0}', Math.floor(diffInHours).toString());
    } else {
      return this.settings.minuteFormat.replace('{0}', Math.floor(diffInMinutes).toString());
    }
  }
}
